import { QueryClient } from 'react-query'
import { Query } from '../../../hooks/queries'

// If routes are mutated, we should invalidate queries that have loaded route coverage data on other pages
// because we know that the route data on the server has changed.
export function routeMutationOnSuccess({
  queryClient,
  onSuccess
}: {
  queryClient: QueryClient
  onSuccess: () => void
}) {
  onSuccess()
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  invalidateVrRouteCoverageQueries(queryClient)
}

export function invalidateVrRouteCoverageQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries([Query.VR_ROUTE_COVERAGE], {
    exact: false
  })
}
